import { ComponentProps } from 'react';
import { asBlock } from '../../../_lib/BlockFetcher';
import { ElementType } from '../../../types/api/ElementType';
import { ContentWrapper } from '../../../components/blocks/ContentWrapper/ContentWrapper';

export const FaqContentWrapperBlock = asBlock(ContentWrapper, ElementType.contentWrapper);
export type FaqContentWrapperBlock = ComponentProps<typeof FaqContentWrapperBlock>;
